import Input, { InputProps } from '@/components/Input';

import { fieldWrapper } from '@/components/Field';

export type FlightNumberInputProps = {} & InputProps;

const FlightNumberOrLoopNameInput = (props: FlightNumberInputProps): JSX.Element => {
  return (
    <Input
      {...props}
      onBlur={({ target }) => {
        let updated = target?.value;
        if (Number.isNaN(Number.parseInt(updated, 10))) return updated;
        updated = `${target.value || ''}`.replace(/^[0]+/, '');
        updated = updated.padStart(4, '0');
        props?.onChange?.(updated);
      }}
      value={props?.value}
    />
  );
};

export const FlightNumberOrLoopNameInputField = fieldWrapper<FlightNumberInputProps>(FlightNumberOrLoopNameInput);
